import Card from "react-bootstrap/Card"
import Placeholder from "react-bootstrap/Placeholder"

export default function PlaceProfileHolder() {
    return (
        <div className="d-flex justify-content-around">
            <Card className="card h-100" style={{ width: "100%" }}>
                <Card.Body>
                    <Placeholder.Button
                        variant="secondary"
                        animation="glow"
                        xs={5}
                        className="mt-3 risk-badge"
                    />
                    <Placeholder as={Card.Title} animation="glow">
                        <Placeholder xs={6} />
                    </Placeholder>
                    <Placeholder
                        as={Card.Text}
                        animation="glow"
                        className="text-start"
                    >
                        <Placeholder xs={7} /> <Placeholder xs={4} />{" "}
                        <Placeholder xs={4} /> <Placeholder xs={6} />{" "}
                        <Placeholder xs={7} /> <Placeholder xs={4} />{" "}
                        <Placeholder xs={3} /> <Placeholder xs={6} />{" "}
                        <Placeholder xs={7} /> <Placeholder xs={4} />{" "}
                        <Placeholder xs={4} /> <Placeholder xs={6} />{" "}
                        <Placeholder xs={7} /> <Placeholder xs={4} />{" "}
                        <Placeholder xs={4} /> <Placeholder xs={6} />{" "}
                        <Placeholder xs={8} />
                    </Placeholder>
                </Card.Body>
            </Card>
        </div>
    )
}
